// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Urkb","header":"ReportDetails_header__1d7NP","title":"ReportDetails_title__3PsU7","left":"ReportDetails_left__3zpW9"};